"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var StyledSvg = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: auto;\n    color: ", ";\n"], ["\n    margin: auto;\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorControlIcon;
});
exports.PreviousIcon = function () { return (react_1.default.createElement(StyledSvg, { viewBox: "0 0 11 7", width: "11px", height: "7px" },
    react_1.default.createElement("polygon", { fill: "currentColor", points: "4 7 0 3.5 4 0 4 3 11 3 11 4 4 4 4 7" }))); };
var templateObject_1;
//# sourceMappingURL=PreviousIcon.js.map